export default __webpack_public_path__ + "static/media/use_action_back_zc.a8e4c493.png";